export default __webpack_public_path__ + "static/inline-edit-textfield-do-a5daf355cb996358d24281cdd7130398.png";